import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentLocationTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetLocationTypeApi`,
    method: 'get',
  });
};

export type ShipmentLocationTypesResponse = {
  codeId: 'B'; // B, O, D
  codeDesc: 'Both'; // Both, Origin, Destination
  value1: null;
  value2: null;
  value3: null;
  string1: null;
  string2: null;
  string3: null;
}[];

export const fetchShipmentLocationTypesList = async (): Promise<ShipmentLocationTypesResponse> => {
  const response: AxiosResponse<ShipmentLocationTypesResponse> = await getShipmentLocationTypesAPI();
  return response.data;
};
